import { bunja } from 'bunja';
import { atom } from 'jotai';

import { postUserPasswordApi } from '@flipster/apis/v1/user';
import { User } from '@flipster/apis/v1/user/types';
import { RouterScope } from '@flipster/react/providers/route';
import { alert } from '@flipster/ui/Alert';
import { convertDate } from '@flipster/utils/datetime';

// context:
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728872045872999
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728963201328899
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728963317151339
export const ninetyDaysPasswordUpdateBunja = bunja(() => {
  const router = bunja.use(RouterScope);
  const modalOpenAtom = atom<boolean>(false);

  function shouldShowModal(passwordChangeRequiredAt: Date | null): boolean {
    if (!passwordChangeRequiredAt) return false;
    return passwordChangeRequiredAt < new Date();
  }

  function openPasswordChangeRequiredModal(me: User): void {
    if (!shouldShowModal(convertDate(me.passwordChangeRequiredAt))) return;
    alert.show({
      title: 'Password update needed',
      message: 'For better security, we recommend updating your password.',
      closeText: 'Later',
      onClose() {
        postUserPasswordApi({ changePasswordLater: true });
      },
      withClose: true,
      confirmText: 'Update now',
      onConfirm() {
        router.push('/user/account?openModal=password%3Achange');
      },
    });
  }

  return {
    modalOpenAtom,
    openPasswordChangeRequiredModal,
  };
});
ninetyDaysPasswordUpdateBunja.debugLabel = 'ninetyDaysPasswordUpdateBunja';
